import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinhowrah() {



  const cardData =
  {
    keyword: ' Corporate Cab Service in Howrah',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Howrah',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Service in Howrah, catering to the transportation needs of industrial areas, business hubs, and corporate offices across the region. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and timely travel for employees, supervisors, clients, and senior executives. Whether it is daily office commute, industrial visits, airport transfers, inter-office travel, business meetings, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Howrah.',

    top: 'Top Places to Visit in Howrah with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Howrah Bridge (Rabindra Setu)",
    "description": "Howrah Bridge is the most iconic symbol of Howrah and one of the world’s largest cantilever bridges. Completed in 1943, it connects Howrah with Kolkata over the Hooghly River and carries thousands of pedestrians and vehicles every day. The steel structure, built without using a single nut or bolt, represents a technological marvel of its time. Walking across the bridge provides a close experience of the river, ferry ghats, bustling marketplaces, and the lively rhythm of daily life in the twin cities. At night, the bridge glows beautifully with illumination, showcasing Howrah’s heritage and pride."
  },
  {
    "title": "Howrah Railway Station",
    "description": "Howrah Junction, established in 1854, is one of the oldest and busiest railway stations in India. With 23 platforms and a massive red-brick colonial structure, it serves millions of passengers annually and connects Eastern India with major cities across the country. The station is well known for its grand façade, high arched ceilings, heritage stairways, and extensive networks of shops and eateries. The view of trains arriving with Howrah Bridge in the backdrop is a classic scene that reflects the historical charm and importance of this transportation landmark."
  },
  {
    "title": "Belur Math",
    "description": "Belur Math, the global headquarters of the Ramakrishna Mission, is located on the western bank of the Hooghly River. Founded by Swami Vivekananda in 1897, the temple complex blends Hindu, Islamic, and Christian architectural elements as a symbol of religious unity. The peaceful gardens, meditation spaces, and museum featuring the life and teachings of Sri Ramakrishna and Swami Vivekananda attract devotees and learners from around the world. Watching the evening Ganga aarti or simply spending time along the serene riverfront provides a deeply spiritual and calming experience."
  },
  {
    "title": "Botanical Garden (Acharya Jagadish Chandra Bose Indian Botanic Garden)",
    "description": "Established in 1787, the Botanical Garden in Howrah is one of the largest and oldest botanical gardens in India. It houses more than 12,000 species of exotic and indigenous plants spread across lush green landscapes, riverside trails, and wide open lawns. The biggest attraction is the Great Banyan Tree, believed to be over 250 years old, spreading across nearly 4 acres and supported by hundreds of aerial roots—making it look like a small forest on its own. The garden is ideal for photography, nature walks, botany research, and peaceful escapes from city life."
  },
  {
    "title": "Vidya Mandir Science Museum",
    "description": "Vidya Mandir Science Museum is an educational center designed to encourage scientific learning among students and young visitors. It features interactive exhibits, science-based displays, physics and chemistry models, and hands-on learning stations that make education more engaging and practical. The museum regularly organizes workshops, demonstrations, and events that promote curiosity and critical thinking. It is an excellent destination for school groups and families seeking to combine fun with learning."
  },
  {
    "title": "Santragachi Jheel",
    "description": "Santragachi Jheel is a large freshwater lake and an important winter habitat for migratory birds from Central Asia and Siberia. Each year, species like gadwalls, northern pintails, and lesser whistling ducks flock to the lake, delighting birdwatchers and wildlife photographers. Surrounded by greenery and peaceful water views, the jheel offers a tranquil escape within the city. Early mornings and winter months are especially ideal for nature lovers, making it a scenic and eco-rich attraction in Howrah."
  },
  {
    "title": "Avani Riverside Mall",
    "description": "Avani Riverside Mall is a modern shopping and entertainment hub situated along the banks of the Hooghly River. The mall features popular retail stores, food courts, branded outlets, gaming zones, and a multiplex cinema, offering a complete day-out experience for families and youth. Its riverside location and well-designed interiors provide a relaxing atmosphere after shopping or dining. The mall has become a preferred contemporary hangout spot, blending urban experiences with scenic river views."
  },
  {
    "title": "Andul Rajbari",
    "description": "Andul Rajbari is a historically significant palace and estate reflecting the lifestyle and architecture of Bengal’s aristocratic zamindar families. Built in the 19th century, the estate features magnificent arches, large courtyards, tall pillars, and elaborate colonial-era detailing that still carries the charm of its golden past. Although parts of the structure have aged, the palace remains an important cultural landmark where visitors can explore Bengal’s architectural evolution and social heritage. It offers a perfect setting for heritage photography and historical enthusiasts."
  },
  {
    "title": "Bata Factory & Township",
    "description": "The Bata Factory and Township in Batanagar is one of the earliest planned industrial townships in India, dating back to the British era. Built to house workers of the Bata Company, the township includes residential quarters, parks, schools, playgrounds, markets, and colonial-era structures. It represents an early example of industrial urban planning, where industry and community coexisted harmoniously. The old factory buildings and township layout provide an interesting look into Howrah’s industrial heritage and urban development."
  },
  {
    "title": "Ramrajatala Mandir",
    "description": "Ramrajatala Mandir is a renowned temple famous for its centuries-old Ram Navami celebrations, which continue for several weeks rather than a single day. The temple complex draws devotees from across Howrah and neighboring districts, especially during festive seasons. Traditional music, rituals, decorative pandals, and cultural programs add to the religious atmosphere, making it a major cultural event in the region. The temple stands as a spiritual landmark that preserves age-old customs and community traditions."
  }
],


"services": [
  {
    "name": "Howrah Corporate Shuttle",
    "description": "Howrah Corporate Shuttle provides high-capacity, scheduled shuttle services for employees commuting to corporate offices, industrial zones, and IT parks in Howrah. The service features AC minibuses, optimized routes, GPS tracking, and professional drivers to ensure safe and timely transportation for large teams."
  },
  {
    "name": "Employee Cab Howrah",
    "description": "Employee Cab Howrah offers dedicated cab services for daily workforce commute, providing punctual pick-ups and drop-offs, trained chauffeurs, and modern vehicles for reliable and comfortable travel across Howrah."
  },
  {
    "name": "Business Cab Howrah",
    "description": "Business Cab Howrah delivers premium corporate travel solutions for executives, client meetings, airport transfers, and inter-office travel. With sedans and SUVs, professional drivers, and real-time tracking, it ensures comfort, safety, and punctuality."
  },
  {
    "name": "Staff Pickup Drop Howrah",
    "description": "Staff Pickup Drop Howrah provides organized, route-based employee transportation with focus on reliability, safety, and convenience for daily office commutes and shift-based operations in Howrah."
  },
  {
    "name": "Office Cab Howrah",
    "description": "Office Cab Howrah offers structured office pick-up and drop services for corporate staff with pre-planned routes, trained chauffeurs, and real-time vehicle monitoring for a seamless commuting experience."
  },
  {
    "name": "Monthly Corporate Cab Howrah",
    "description": "Monthly Corporate Cab Howrah provides long-term, contract-based corporate transportation solutions including dedicated vehicles, GPS monitoring, driver management, and shift-aligned commute plans for organizations."
  },
  {
    "name": "Affordable Cab Howrah",
    "description": "Affordable Cab Howrah delivers cost-effective corporate mobility services without compromising on safety or reliability. Ideal for SMEs and mid-sized businesses, it features efficient routing and well-maintained vehicles."
  },
  {
    "name": "Outstation Cab Howrah",
    "description": "Outstation Cab Howrah provides long-distance corporate travel for business trips, client visits, and intercity commutes. Vehicles include sedans and SUVs with trained chauffeurs and GPS tracking for secure and comfortable journeys."
  },
  {
    "name": "Sedan Cab Howrah",
    "description": "Sedan Cab Howrah offers executive sedans for managers, VIPs, and employees, featuring well-maintained interiors, safety protocols, and professional drivers to ensure a premium commuting experience."
  },
  {
    "name": "SUV Cab Howrah",
    "description": "SUV Cab Howrah provides spacious and comfortable SUVs suitable for team commutes, senior management travel, and outstation trips. Vehicles are equipped with advanced safety features and professional chauffeurs."
  },
  {
    "name": "Company Cab Howrah",
    "description": "Company Cab Howrah offers complete corporate cab solutions for employee and executive travel, including fleet management, driver assignment, and route optimization for daily and special commutes."
  },
  {
    "name": "Industrial Transport Howrah",
    "description": "Industrial Transport Howrah provides specialized employee transportation for factories, industrial zones, and large workforce operations. Services include route planning, timely pickups, and fleet management for high-volume employee movement."
  },
  {
    "name": "Corporate Fleet Howrah",
    "description": "Corporate Fleet Howrah delivers end-to-end fleet management services including sedans, SUVs, and shuttle vehicles. It ensures vehicle maintenance, driver management, compliance monitoring, and scalable transport solutions for companies in Howrah."
  },
  {
    "name": "Employee Mobility Howrah",
    "description": "Employee Mobility Howrah offers flexible, technology-enabled commuting solutions for corporate employees, integrating GPS tracking, real-time monitoring, and optimized scheduling to streamline workforce transportation."
  },
  {
    "name": "Best Corporate Cabs Howrah",
    "description": "Best Corporate Cabs Howrah provides premium corporate mobility services with top-quality vehicles, verified drivers, and superior safety protocols, catering to executives, managers, and VIP staff."
  }
],

"tableData": [
  ["Howrah Corporate Shuttle", "Employee Cab Howrah"],
  ["Business Cab Howrah", "Staff Pickup Drop Howrah"],
  ["Office Cab Howrah", "Monthly Corporate Cab Howrah"],
  ["Affordable Cab Howrah", "Outstation Cab Howrah"],
  ["Sedan Cab Howrah", "SUV Cab Howrah"],
  ["Company Cab Howrah", "Industrial Transport Howrah"],
  ["Corporate Fleet Howrah", "Employee Mobility Howrah"],
  ["Best Corporate Cabs Howrah", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Howrah",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers reliable corporate cab services in Howrah, ensuring smooth and efficient transportation for employees and business executives across the city."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We provide punctual pickups and drop-offs across Howrah’s business districts, corporate offices, and industrial zones, helping employees reach work and meetings on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs deliver safe, courteous, and disciplined travel, ensuring a secure and comfortable commuting experience for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for reliable and comfortable corporate travel in Howrah."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible and tailored cab rental plans to meet the commuting requirements of companies and employees in Howrah."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are sanitized regularly and equipped with modern safety features, offering secure and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is managed effortlessly through our streamlined booking process and reliable coordination, making employee transport hassle-free."
  }
]













  }

  
const faqData = [
  {
    question: 'Do you provide corporate cab services in Howrah?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional corporate cab services for companies and offices in Howrah.',
  },
  {
    question: 'What types of corporate transportation services are available in Howrah?',
    answer: 'We provide employee transportation, corporate pickups and drops, airport transfers, shuttle services, and complete fleet management for corporate clients.',
  },
  {
    question: 'Do you support daily employee commute services in Howrah?',
    answer: 'Yes, we offer structured daily commute solutions with optimized routes, timely pickups, and multi-shift support for employees.',
  },
  {
    question: 'How can companies book corporate cab services in Howrah?',
    answer: 'Companies can book through our website, mobile app, or by contacting our 24×7 dedicated corporate support team.',
  },
  {
    question: 'Which vehicles are available for corporate cab services in Howrah?',
    answer: 'We offer hatchbacks, sedans, SUVs, Innova Crysta, luxury cars, tempo travellers, and electric vehicles based on corporate requirements.',
  },
  {
    question: 'Do you offer long-term corporate cab contracts in Howrah?',
    answer: 'Yes, we provide monthly, quarterly, and annual corporate transportation contracts with flexible pricing and comprehensive fleet management.',
  },
  {
    question: 'Are your vehicles equipped with GPS and safety features?',
    answer: 'All vehicles are GPS-enabled, regularly sanitized, and driven by trained and background-verified chauffeurs for maximum safety.',
  },
  {
    question: 'Do you provide transportation for night shifts and rotational shifts in Howrah?',
    answer: 'Absolutely. We provide reliable transport solutions for night shifts, early morning shifts, weekend operations, and rotational schedules.',
  },
  {
    question: 'What payment options are available for corporate cab services?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and provide consolidated monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Subhankar Mukherjee',
    feedback: 'Dependable corporate cab service for our Howrah office. Vehicles are clean, and drivers are professional and punctual.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ananya Ghosh',
    feedback: 'Excellent service for employee commutes. Timely pickups, smooth rides, and courteous drivers make it a great choice.',
    rating: 5,
  },
];












































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Howrah",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-howrah.jpg", // replace with actual image URL
  "description":
    "Pune Corporate Cars India Private Limited provides professional corporate cab services in Howrah, including employee cabs, corporate shuttle, business cabs, staff pickup & drop, office transportation, monthly corporate cabs, affordable and executive cabs, outstation trips, sedan & SUV corporate cabs, industrial transport, employee mobility solutions, and complete corporate fleet management.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-howrah"
  }
};













  return (
    <div>
<Helmet>
  <title>Corporate Cab Service in Howrah | Employee & Business Cab Service</title>

  <meta
    name="description"
    content="Professional corporate cab services in Howrah including employee cabs, corporate shuttle, business cabs, staff pickup & drop, office transportation, monthly corporate cabs, affordable and executive cabs, outstation trips, sedan & SUV corporate cabs, industrial transport, employee mobility solutions, and corporate fleet management."
  />

  <meta
    name="keywords"
    content="Howrah Corporate Shuttle, Employee Cab Howrah, Business Cab Howrah, Staff Pickup Drop Howrah, Office Cab Howrah, Monthly Corporate Cab Howrah, Affordable Cab Howrah, Outstation Cab Howrah, Sedan Cab Howrah, SUV Cab Howrah, Company Cab Howrah, Industrial Transport Howrah, Corporate Fleet Howrah, Employee Mobility Howrah, Best Corporate Cabs Howrah"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/91.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinhowrah;